import { Toaster as Sonner, toast } from "sonner"

/** Pas de ThemeProvider dans l’app : forcer le thème sombre pour éviter des toasts vides / illisibles. */
const Toaster = ({ theme = "dark", ...props }) => {
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-slate-900 group-[.toaster]:text-slate-100 group-[.toaster]:border-slate-600 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-slate-400",
          actionButton:
            "group-[.toast]:bg-cyan-500 group-[.toast]:text-slate-900",
          cancelButton:
            "group-[.toast]:bg-slate-700 group-[.toast]:text-slate-200",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
